import { ReactNode } from 'react';

import { Box, Stack } from '@cast/design-system';

type TwoColumnChartLayoutProps = {
  summary?: ReactNode;
  leftChart: ReactNode;
  rightChart: ReactNode;
  bottomContent?: ReactNode;
  testId?: string;
};

export const TwoColumnChartLayout = ({
  summary,
  leftChart,
  rightChart,
  bottomContent,
  testId,
}: TwoColumnChartLayoutProps) => {
  return (
    <Stack gap={16} data-testid={testId}>
      {summary}
      <Box
        display="grid"
        gridTemplateColumns={{ xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' }}
        gap={16}
      >
        {leftChart}
        {rightChart}
      </Box>
      {bottomContent}
    </Stack>
  );
};
